import React from 'react'
import { getPictureProps, Grid, Heading, PageSection as Section } from '@superhi/design'

import JoinNowInfo from '../Hero/components/JoinNowInfo'

import { Wrapper, BackgroundImage, Content } from './styles'

export const backgroundImageProps = getPictureProps({
  small: {
    path: 'https://superhi.s3.amazonaws.com/assets/images/unlimited-membership/cta-small.png',
    width: 100,
    options: {
      fm: 'png8',
    },
  },
  medium: {
    path: 'https://superhi.s3.amazonaws.com/assets/images/unlimited-membership/cta-medium.png',
    width: 100,
    options: {
      fm: 'png8',
    },
  },
  large: {
    path: 'https://superhi.s3.amazonaws.com/assets/images/unlimited-membership/cta-large.png',
    width: 100,
    options: {
      fm: 'png8',
    },
  },
  xlarge: {
    path: 'https://superhi.s3.amazonaws.com/assets/images/unlimited-membership/cta-large.png',
    width: 100,
    options: {
      fm: 'png8',
    },
  },
})

const GRID_1_CELL_1_SPAN: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: [2, 7],
  large: [3, 10],
}

type Props = {}

const MembershipJoinCallout: React.FC<React.PropsWithChildren<Props>> = () => (
  <Wrapper data-component-name="MembershipJoinCallout">
    <BackgroundImage
      {...backgroundImageProps}
      blurHash="elSgoSofHXf9S*o|tOaxxtSiR5oHWXjbbdW;V@WDj[a$oLj[oejvjr"
      fit="cover"
      position="center center"
      alt=""
      lazy
    />

    <Section>
      <Grid>
        <Grid.Cell span={GRID_1_CELL_1_SPAN}>
          <Content>
            <Heading level="2" maxWidth={14} color="BLUE_50">
              Say hi to Unlimited
            </Heading>

            <JoinNowInfo />
          </Content>
        </Grid.Cell>
      </Grid>
    </Section>
  </Wrapper>
)

export default MembershipJoinCallout
